import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#505050",
      "fill-rule": "evenodd",
      d: "M20.5 6.691C20.5 6 19.975 5.5 19.4 5.5s-1.1.5-1.1 1.191c0 .693.526 1.192 1.1 1.192s1.1-.5 1.1-1.192m1.5 0c0 1.452-1.13 2.692-2.6 2.692q-.282 0-.545-.059l-2.23 4.212c.467.491.75 1.165.75 1.892 0 1.451-1.13 2.69-2.6 2.69s-2.6-1.239-2.6-2.69c0-.6.193-1.163.522-1.618l-2.584-3.616a2.52 2.52 0 0 1-1.433.101l-2.23 4.212c.467.492.75 1.165.75 1.891 0 1.452-1.13 2.692-2.6 2.692S2 17.85 2 16.398s1.13-2.691 2.6-2.691q.282 0 .545.058l2.23-4.212a2.75 2.75 0 0 1-.75-1.89c0-1.453 1.13-2.692 2.6-2.692s2.6 1.24 2.6 2.691c0 .6-.192 1.162-.522 1.617l2.585 3.617a2.52 2.52 0 0 1 1.433-.101l2.23-4.212a2.75 2.75 0 0 1-.75-1.892c0-1.451 1.13-2.69 2.6-2.691C20.87 4 22 5.24 22 6.691M5.7 16.398c0-.692-.526-1.191-1.1-1.191s-1.1.499-1.1 1.191.526 1.191 1.1 1.192 1.1-.5 1.1-1.192m3.525-9.927c.574 0 1.1.499 1.1 1.191s-.526 1.191-1.1 1.191-1.1-.499-1.1-1.19c0-.693.526-1.192 1.1-1.192m6.65 8.957c0-.693-.526-1.192-1.1-1.192s-1.1.5-1.1 1.191c0 .693.526 1.192 1.1 1.192s1.1-.5 1.1-1.191",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }